import React from 'react';
import s from './Journey.module.css';

const STEPS = [
  { icon: 'ti-brand-whatsapp', label: 'WhatsApp invite', sub: 'CPCL sends link', done: true },
  { icon: 'ti-device-mobile', label: 'OTP verify', sub: 'Mobile number', done: true },
  { icon: 'ti-upload', label: 'Submit invoice', sub: 'PDF + docs', done: true },
  { icon: 'ti-eye', label: 'Track status', sub: 'WhatsApp updates', done: false },
  { icon: 'ti-bolt', label: 'Get paid early', sub: 'Optional advance', done: false },
];

function PhoneFrame({ label, children }) {
  return (
    <div className={s.phoneWrap}>
      <div className={s.phone}>
        <div className={s.phoneBar}>
          <span className={s.pbBack}>←</span>
          <span className={s.pbName}>CPCL Vendor Portal</span>
          <span className={s.pbDot} />
        </div>
        <div className={s.phoneBody}>
          {children}
          <div className={s.waInputRow}>
            <input className={s.waInp} placeholder="Type a message" readOnly />
            <button className={s.waSend} aria-label="Send">↑</button>
          </div>
        </div>
      </div>
      <div className={s.phoneLabel}>{label}</div>
    </div>
  );
}

function Bubble({ type, tag, children, time }) {
  return (
    <div className={`${s.bubble} ${type === 'out' ? s.bubbleOut : s.bubbleIn}`}>
      {tag && <span className={s.btag}>{tag}</span>}
      {children}
      <div className={s.btime}>{time}</div>
    </div>
  );
}

function WaBtn({ children, highlight }) {
  return (
    <button className={s.waBtn} style={highlight ? { color: '#0F6E56', fontWeight: 600 } : {}}>
      {children}
    </button>
  );
}

export default function Journey() {
  return (
    <div>
      <div className={s.sectionLabel}>5 touchpoints — from invite to paid</div>

      {/* Journey Steps */}
      <div className={s.journey}>
        <div className={s.journeyLine} />
        {STEPS.map((step, i) => (
          <div key={i} className={s.jStep}>
            <div className={`${s.jDot} ${step.done ? s.jDotDone : s.jDotActive}`}>
              <i className={`ti ${step.icon}`} />
            </div>
            <div className={s.jLbl}>{step.label}</div>
            <div className={s.jSub}>{step.sub}</div>
          </div>
        ))}
      </div>

      {/* Phone mockups */}
      <div className={s.phoneRow}>
        {/* Step 1 */}
        <PhoneFrame label="Step 1 — Invite + OTP">
          <div className={s.waBubbleWrap}>
            <Bubble type="in" tag="CPCL Finigenie" time="09:00">
              Namaste! You've been registered as an approved vendor for Chennai Petroleum Corporation Ltd (CPCL).
            </Bubble>
            <Bubble type="in" time="09:00">
              To activate your account and submit invoices, tap the button below. No app download needed.
            </Bubble>
          </div>
          <WaBtn>Activate vendor account →</WaBtn>
          <div className={s.waBubbleWrap}>
            <Bubble type="in" time="09:01">
              Your OTP is <strong>847291</strong>. Valid for 5 minutes. Do not share this with anyone.
            </Bubble>
            <Bubble type="out" time="09:01">847291</Bubble>
            <Bubble type="in" tag="Verified" time="09:01">
              Account activated. You can now submit invoices and track payment status directly on WhatsApp.
            </Bubble>
          </div>
        </PhoneFrame>

        {/* Step 2 */}
        <PhoneFrame label="Step 2 — Submit + menu">
          <div className={s.waBubbleWrap}>
            <Bubble type="in" time="10:14">What would you like to do today?</Bubble>
          </div>
          <WaBtn>Submit a new invoice</WaBtn>
          <WaBtn>Check payment status</WaBtn>
          <WaBtn>Apply for early payment</WaBtn>
          <div className={s.waBubbleWrap}>
            <Bubble type="out" time="10:14">Submit a new invoice</Bubble>
            <Bubble type="in" time="10:14">
              Upload your invoice PDF and supporting documents (GST certificate, delivery note, NOC if applicable).
            </Bubble>
            <Bubble type="out" time="10:15">
              <i className="ti ti-paperclip" /> INV-2024-1183.pdf
            </Bubble>
            <Bubble type="in" tag="Received" time="10:15">
              Invoice received. AI validation in progress — you'll get a status update within 2 minutes.
            </Bubble>
          </div>
        </PhoneFrame>

        {/* Step 3 */}
        <PhoneFrame label="Step 3 — Status + early pay offer">
          <div className={s.waBubbleWrap}>
            <Bubble type="in" tag="AI validated" time="10:17">
              Invoice INV-2024-1183 validated. Compliance score: 94/100. Forwarded to Procurement for approval.
            </Bubble>
            <Bubble type="in" tag="Approved" time="11:42">
              Procurement approved your invoice. Moving to Finance review.
            </Bubble>
            <Bubble type="in" tag="Payment ready" time="14:30">
              Your invoice of ₹18,40,000 is cleared for payment. Expected credit: 3 Jul 2026.
            </Bubble>
            <Bubble type="in" time="14:30">
              Want to receive payment earlier? You can get paid today at a small discount.
            </Bubble>
          </div>
          <WaBtn highlight>Get paid today (early payment)</WaBtn>
          <WaBtn>No thanks, wait for standard date</WaBtn>
        </PhoneFrame>
      </div>
    </div>
  );
}
